interface MembershipCTAProps {
  isAccepting: boolean;
  requirements: string[];
}

export function MembershipCTA({ isAccepting }: MembershipCTAProps) {
  if (!isAccepting) return null;

  return (
    <section>
      <div className="bg-white rounded-lg border border-neutral-200 shadow-soft p-6">
        <div className="text-center max-w-3xl mx-auto">
        <h2 className="text-2xl sm:text-3xl font-display font-semibold text-primary-700 mb-6 text-center">
          Become a Member
        </h2>

        <div className="space-y-4 text-base sm:text-lg font-body text-neutral-700">
          <p>
            The Wayland Rod &amp; Gun Club is currently welcoming{' '}
            <a
              href="/membership"
              className="text-primary-600 hover:text-primary-700 font-medium underline decoration-primary-300 hover:decoration-primary-500 transition-colors"
            >
              Membership
            </a>{' '}
            applications.
          </p>

          <p className="leading-relaxed">
            Bring a legibly filled out application form, application fee, and come to the next General Meeting at 7 pm for an interview
          </p>
        </div>

        <div className="mt-6">
          <div className="inline-flex items-center px-4 py-2 bg-white rounded-full">
            <span className="w-2 h-2 bg-primary-600 rounded-full mr-2 animate-pulse"></span>
            <span className="text-primary-600 font-medium text-sm">Applications Open</span>
          </div>
        </div>
        </div>
      </div>
    </section>
  );
}